import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  nl: {
    // Navbar
    nav: {
      home: 'Home',
      photos: "Foto's",
      menu: 'Menu',
      contact: 'Contact',
      location: 'Locatie',
      private: 'Private',
      events: 'Events',
      reserve: 'Reserveren',
    },
    // Hero
    hero: {
      tagline: 'Sip • Share • Taste... Enjoy the Moment',
      location: 'Middelkerke',
      viewMenu: 'Bekijk Menu',
      reserve: 'Reserveren',
    },
    // About section
    about: {
      welcome: 'Welkom bij',
      title1: 'Een unieke',
      title2: 'beleving',
      description: 'BARBAAR is meer dan een cocktail- en loungebar. Het is een ontmoetingsplek waar je kunt genieten van huisgemaakte en unieke cocktails, overheerlijke sharing gerechten en een uitgebreide selectie wijnen en bubbels. Ons industrieel interieur met warme accenten creëert de perfecte sfeer voor een onvergetelijke avond. Zeker niet te vergeten, ons zonovergoten terras met zicht op het prachtige Silt Casino. Geen mooiere locatie om van de perfecte zonsondergang te genieten.',
      cocktails: 'Cocktails',
      sharingDishes: 'Sharing Dishes',
      lateNight: 'Tot Laat',
    },
    // Specialties
    specialties: {
      discover: 'Ontdek',
      title: 'Onze Specialiteiten',
      cocktailsTitle: 'Signature Cocktails',
      cocktailsDesc: 'Van klassiekers tot creatieve huisrecepten. Onze barkeepers maken elke cocktail met passie.',
      sharingTitle: 'Sharing Dishes',
      sharingDesc: 'Onze sharing dishes zijn perfect om samen te ontdekken en te genieten.',
      winesTitle: 'Wijnen & Bubbels',
      winesDesc: 'Maak uw keuze uit onze mooie selectie aan wijnen per glas of geniet van een flesje Rosé op ons zonovergoten terras.',
      fullMenu: 'Volledig Menu',
    },
    // Gallery
    gallery: {
      subtitle: 'Sfeerbeelden',
      title: 'Onze Ruimte',
      viewAll: "Bekijk Alle Foto's",
    },
    // CTA
    cta: {
      title: 'Kom Langs',
      viewLocation: 'Bekijk Locatie',
      sendMessage: 'Stuur een Bericht',
    },
    // Photos page
    photos: {
      subtitle: 'Galerij',
      title: "Foto's",
      description: 'Ontdek de sfeer van BARBAAR. Van ons karakteristieke koperen bar tot de gezellige zithoeken met kleurrijke velours stoelen.',
      industrialTitle: 'Industrieel Design',
      industrialDesc: 'Ruw beton, stalen rekken met sierlijke verlichting en een houten plafond vormen het decor.',
      lightingTitle: 'Warme Verlichting',
      lightingDesc: 'Edison lampen en koperen hangers zorgen voor een intieme, warme sfeer.',
      accentsTitle: 'Kleurrijke Accenten',
      accentsDesc: 'Velours stoelen in teal, mosterd en roze geven elk hoekje persoonlijkheid.',
    },
    // Menu page
    menuPage: {
      subtitle: 'Ons Aanbod',
      title: 'Menu',
      description: 'Van huisgemaakt cocktails tot verfrissende wijntjes, van verfijnde sharing dishes tot verfrissende spritzes, ... Ontdek ons volledige aanbod hieronder.',
      loading: 'Menu laden...',
      tabs: {
        cocktails: 'Cocktails',
        aperitief: 'Aperitief',
        wines: 'Bubbels & Wijnen',
        spirits: 'Spirits',
        beers: 'Bieren',
        drinks: 'Dranken',
        sharingDishes: 'Sharing Dishes',
      },
    },
    // Contact page
    contactPage: {
      subtitle: 'Neem Contact Op',
      title: 'Contact',
      description: 'Heb je een vraag, opmerking of wil je reserveren? Stuur ons een bericht en we nemen zo snel mogelijk contact met je op.',
      formTitle: 'Stuur een Bericht',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      message: 'Bericht',
      namePlaceholder: 'Je naam',
      emailPlaceholder: 'je@email.com',
      phonePlaceholder: '+32 XXX XX XX XX',
      messagePlaceholder: 'Schrijf hier je bericht...',
      send: 'Verstuur Bericht',
      sending: 'Verzenden...',
      success: 'Bericht verzonden! We nemen zo snel mogelijk contact met u op.',
      error: 'Er ging iets mis. Probeer het later opnieuw.',
      address: 'Adres',
      openingHours: 'Openingsuren',
      closed: 'Gesloten',
      holidayNote: 'Tijdens vakanties 7 op 7 geopend',
      kitchenNote: 'Keuken geopend van 11u30 tot 22u00',
      summerTitle: 'Juli & Augustus:',
      summerKitchenNote: 'Keuken geopend van 11u30 tot 23u00',
    },
    // Location page
    locationPage: {
      subtitle: 'Vind Ons',
      title: 'Locatie',
      description: 'BARBAAR bevindt zich in het hart van Middelkerke, op wandelafstand van het strand en de zeedijk.',
      address: 'Adres',
      planRoute: 'Route plannen',
      openingHours: 'Openingsuren',
      closed: 'Gesloten',
      holidayNote: 'Tijdens vakanties 7 op 7 geopend',
      kitchenNote: 'Keuken geopend van 11u30 tot 22u00',
      summerTitle: 'Juli & Augustus:',
      summerKitchenNote: 'Keuken geopend van 11u30 tot 23u00',
      contact: 'Contact',
      sendMessage: 'Stuur een Bericht',
      howToReach: 'Hoe Bereik Je Ons?',
      howToReachDesc: 'Middelkerke is gemakkelijk bereikbaar met de auto, kusttram of openbaar vervoer.',
      byCar: 'Met de Auto',
      byCarDesc: 'Via de E40 richting kust, afrit Middelkerke. Volg de borden naar het centrum. Parkeren kan in de nabijgelegen straten of op de openbare parkings in het centrum.',
      byTram: 'Met de Kusttram',
      byTramDesc: 'Neem de kusttram en stap uit aan halte "Middelkerke Casino". Van daar is het slechts enkele minuten wandelen naar de Parijsstraat.',
      welcomeSubtitle: 'Tot Snel',
      welcomeTitle: 'We Verwelkomen Je Graag',
      welcomeDesc: 'Of je nu komt voor een snelle cocktail na het werk, een gezellig tapas-avondje met vrienden, of een romantisch diner voor twee - bij BARBAAR ben je altijd welkom. Onze warme sfeer en gastvrije service maken elk bezoek bijzonder.',
      viewMenu: 'Bekijk Menu',
    },
    // Footer
    footer: {
      description: 'Cocktails, Wijnen, Bubbels en sharing gerechten in het hart van Middelkerke. Een trendy loungebar met zicht op het prachtige Silt Casino.',
      tagline: 'Sip • Share • Taste... Enjoy the Moment',
      contact: 'CONTACT',
      navigation: 'NAVIGATIE',
      followUs: 'VOLG ONS',
      rights: 'Alle rechten voorbehouden.',
      responsible: 'Verantwoord genieten',
    // Events page
    eventsPage: {
      subtitle: 'Wat er gebeurt',
      description: 'Ontdek onze evenementen en speciale avonden bij BARBAAR.',
    },
    },
    // Private page
    privatePage: {
      subtitle: 'Exclusief',
      title: 'Private Events',
      intro: 'Maak van uw volgende feest een onvergetelijke belevenis bij Barbaar.',
      looking: 'Bent u op zoek naar een unieke locatie voor een verjaardag, jubileum, huwelijk, communiefeest of een ander bijzonder moment? Bij Barbaar verwelkomen wij u graag in onze trendy loungebar, waar sfeer, stijl en beleving centraal staan.',
      dream: 'Of u nu droomt van een gezellige receptie met verfijnde hapjes, een uitgebreid sharing menu, of een avond vol heerlijke cocktails en muziek \u2013 alles is mogelijk. Met een DJ of live muziek cre\u00ebren we samen de perfecte setting voor uw event.',
      exclusive: 'Barbaar is exclusief af te huren als priv\u00e9 locatie, zodat u en uw gasten ongestoord kunnen genieten. Ons ervaren en gepassioneerde Barbaar-team staat klaar om elk detail tot in de puntjes te verzorgen, volledig op maat van uw wensen.',
      interest: 'Heeft u interesse of wenst u meer informatie? Neem gerust contact met ons op via info@barbaarmiddelkerke.com of bel ons op 0471 55 67 51.',
      hope: 'Wij hopen u binnenkort te mogen verwelkomen op onze unieke locatie aan het Silt Casino, waar we samen van uw event iets bijzonders maken.',
    },
    // Days
    days: {
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag',
    },
  },
  en: {
    // Navbar
    nav: {
      home: 'Home',
      photos: 'Photos',
      menu: 'Menu',
      contact: 'Contact',
      location: 'Location',
      private: 'Private',
      events: 'Events',
      reserve: 'Reserve',
    },
    // Hero
    hero: {
      tagline: 'Sip • Share • Taste... Enjoy the Moment',
      location: 'Middelkerke',
      viewMenu: 'View Menu',
      reserve: 'Reserve',
    },
    // About section
    about: {
      welcome: 'Welcome to',
      title1: 'A unique',
      title2: 'experience',
      description: 'BARBAAR is more than a cocktail and lounge bar. It is a meeting place where you can enjoy homemade and unique cocktails, delicious sharing dishes and an extensive selection of wines and bubbles. Our industrial interior with warm accents creates the perfect atmosphere for an unforgettable evening. Not to forget, our sun-drenched terrace with a view of the beautiful Silt Casino. No better location to enjoy the perfect sunset.',
      cocktails: 'Cocktails',
      sharingDishes: 'Sharing Dishes',
      lateNight: 'Late Night',
    },
    // Specialties
    specialties: {
      discover: 'Discover',
      title: 'Our Specialties',
      cocktailsTitle: 'Signature Cocktails',
      cocktailsDesc: 'From classics to creative house recipes. Our bartenders craft each cocktail with passion.',
      sharingTitle: 'Sharing Dishes',
      sharingDesc: 'Our sharing dishes are perfect to discover and enjoy together.',
      winesTitle: 'Wines & Bubbles',
      winesDesc: 'Choose from our beautiful selection of wines by the glass or enjoy a bottle of Rosé on our sun-drenched terrace.',
      fullMenu: 'Full Menu',
    },
    // Gallery
    gallery: {
      subtitle: 'Atmosphere',
      title: 'Our Space',
      viewAll: 'View All Photos',
    },
    // CTA
    cta: {
      title: 'Come Visit',
      viewLocation: 'View Location',
      sendMessage: 'Send a Message',
    },
    // Photos page
    photos: {
      subtitle: 'Gallery',
      title: 'Photos',
      description: 'Discover the atmosphere of BARBAAR. From our characteristic copper bar to the cozy seating areas with colorful velvet chairs.',
      industrialTitle: 'Industrial Design',
      industrialDesc: 'Raw concrete, steel shelves with elegant lighting and a wooden ceiling set the scene.',
      lightingTitle: 'Warm Lighting',
      lightingDesc: 'Edison lamps and copper pendants create an intimate, warm atmosphere.',
      accentsTitle: 'Colorful Accents',
      accentsDesc: 'Velvet chairs in teal, mustard and pink give each corner personality.',
    },
    // Menu page
    menuPage: {
      subtitle: 'Our Offerings',
      title: 'Menu',
      description: 'From homemade cocktails to refreshing wines, from refined sharing dishes to refreshing spritzes, ... Discover our full range below.',
      loading: 'Loading menu...',
      tabs: {
        cocktails: 'Cocktails',
        aperitief: 'Aperitif',
        wines: 'Bubbles & Wines',
        spirits: 'Spirits',
        beers: 'Beers',
        drinks: 'Drinks',
        sharingDishes: 'Sharing Dishes',
      },
    },
    // Contact page
    contactPage: {
      subtitle: 'Get in Touch',
      title: 'Contact',
      description: 'Have a question, comment or want to make a reservation? Send us a message and we will get back to you as soon as possible.',
      formTitle: 'Send a Message',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'you@email.com',
      phonePlaceholder: '+32 XXX XX XX XX',
      messagePlaceholder: 'Write your message here...',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent! We will contact you as soon as possible.',
      error: 'Something went wrong. Please try again later.',
      address: 'Address',
      openingHours: 'Opening Hours',
      closed: 'Closed',
      holidayNote: 'Open 7 days a week during holidays',
      kitchenNote: 'Kitchen open from 11:30 AM to 10:00 PM',
      summerTitle: 'July & August:',
      summerKitchenNote: 'Kitchen open from 11:30 AM to 11:00 PM',
    },
    // Location page
    locationPage: {
      subtitle: 'Find Us',
      title: 'Location',
      description: 'BARBAAR is located in the heart of Middelkerke, within walking distance of the beach and the promenade.',
      address: 'Address',
      planRoute: 'Plan route',
      openingHours: 'Opening Hours',
      closed: 'Closed',
      holidayNote: 'Open 7 days a week during holidays',
      kitchenNote: 'Kitchen open from 11:30 AM to 10:00 PM',
      summerTitle: 'July & August:',
      summerKitchenNote: 'Kitchen open from 11:30 AM to 11:00 PM',
      contact: 'Contact',
      sendMessage: 'Send a Message',
      howToReach: 'How to Reach Us?',
      howToReachDesc: 'Middelkerke is easily accessible by car, coastal tram or public transport.',
      byCar: 'By Car',
      byCarDesc: 'Via the E40 towards the coast, exit Middelkerke. Follow the signs to the center. Parking is available in nearby streets or at public parking lots in the center.',
      byTram: 'By Coastal Tram',
      byTramDesc: 'Take the coastal tram and get off at "Middelkerke Casino" stop. From there it is just a few minutes walk to Parijsstraat.',
      welcomeSubtitle: 'See You Soon',
      welcomeTitle: 'We Welcome You',
      welcomeDesc: 'Whether you come for a quick cocktail after work, a cozy tapas evening with friends, or a romantic dinner for two - at BARBAAR you are always welcome. Our warm atmosphere and hospitable service make every visit special.',
      viewMenu: 'View Menu',
    },
    // Footer
    footer: {
      description: 'Cocktails, Wines, Bubbles and sharing dishes in the heart of Middelkerke. A trendy lounge bar with a view of the beautiful Silt Casino.',
      tagline: 'Sip • Share • Taste... Enjoy the Moment',
      contact: 'CONTACT',
      navigation: 'NAVIGATION',
      followUs: 'FOLLOW US',
      rights: 'All rights reserved.',
      responsible: 'Enjoy responsibly',
    },
    // Private page
    // Events page
    eventsPage: {
      subtitle: "What's happening",
      description: 'Discover our events and special evenings at BARBAAR.',
    },
    privatePage: {
      subtitle: 'Exclusive',
      title: 'Private Events',
      intro: 'Make your next celebration an unforgettable experience at Barbaar.',
      looking: 'Are you looking for a unique location for a birthday, anniversary, wedding, communion celebration or another special occasion? At Barbaar we welcome you to our trendy lounge bar, where atmosphere, style and experience take center stage.',
      dream: 'Whether you dream of a cozy reception with refined appetizers, an extensive sharing menu, or an evening full of delicious cocktails and music \u2013 everything is possible. With a DJ or live music we create the perfect setting for your event together.',
      exclusive: 'Barbaar is exclusively available for private hire, so you and your guests can enjoy undisturbed. Our experienced and passionate Barbaar team is ready to take care of every detail, fully tailored to your wishes.',
      interest: 'Are you interested or would you like more information? Feel free to contact us at info@barbaarmiddelkerke.com or call us at 0471 55 67 51.',
      hope: 'We hope to welcome you soon at our unique location at the Silt Casino, where together we make your event something special.',
    },
    // Days
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('barbaar-language');
    return saved || 'nl';
  });

  useEffect(() => {
    localStorage.setItem('barbaar-language', language);
  }, [language]);

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'nl' ? 'en' : 'nl');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
